import { render, staticRenderFns } from "./biddingView.vue?vue&type=template&id=4c3b6044&scoped=true&"
import script from "./biddingView.vue?vue&type=script&lang=js&"
export * from "./biddingView.vue?vue&type=script&lang=js&"
import style0 from "./biddingView.vue?vue&type=style&index=0&id=4c3b6044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b6044",
  null
  
)

export default component.exports